import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

type CloValueState = string | number;

/**
 * CloStateService
 * --------------------------------------------------------------------
 * CLO / CLOlite text + lite hour/power + load-feature-file toggle.
 */
@Injectable({ providedIn: "root" })
export class CloStateService {
  readonly cloLiteTxt = new BehaviorSubject<CloValueState>("");
  readonly getCloLiteHead: Observable<CloValueState> = this.cloLiteTxt.asObservable();
  readonly cloTxt = new BehaviorSubject<CloValueState>("");
  readonly getCloHead: Observable<CloValueState> = this.cloTxt.asObservable();
  readonly liteHour = new BehaviorSubject<CloValueState>("");
  readonly getliteHour: Observable<CloValueState> = this.liteHour.asObservable();
  readonly LitePower = new BehaviorSubject<CloValueState>("");
  readonly getlitePower: Observable<CloValueState> = this.LitePower.asObservable();
  readonly cloLoadFeatureFileConfigure = new BehaviorSubject<string>("Normal");
  readonly getCloLoadFeatureFileConfigure: Observable<string> =
    this.cloLoadFeatureFileConfigure.asObservable();

  // Dedicated CLO form-validity signal. Kept separate from the shared
  // graphState.checkGraphIsValid because that observable is also emitted
  // into by CLO-Lite / Dyna Dimmer, which caused isClo to be incorrectly
  // reset to false in Standard mode when their handlers emitted "valid"
  // after CLO had emitted "invalid".
  readonly cloFormValid = new BehaviorSubject<string>("");
  readonly getCloFormValid: Observable<string> = this.cloFormValid.asObservable();

  sendCloLiteText(data: CloValueState): void {
    this.cloLiteTxt.next(data);
  }
  sendCloText(data: CloValueState): void {
    this.cloTxt.next(data);
  }
  sendliteHour(data: CloValueState): void {
    this.liteHour.next(data);
  }
  sendLitePower(data: CloValueState): void {
    this.LitePower.next(data);
  }
  setCloLoadConfigureExtraValidation(data: string): void {
    this.cloLoadFeatureFileConfigure.next(data);
  }
  sendCloFormValid(data: string): void {
    this.cloFormValid.next(data);
  }
}
